import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs/Observable';
import { ConfigModel } from '../models/config-model.model';

@Injectable()
export class ConfigService extends BaseService {

  protected makeModel(data: any): ConfigModel {
    return new ConfigModel(data);
  }

  public index(): Observable<ConfigModel[]> {
    return this.http.get(this.url('config'), this.getRequestOptions())
      .map(this.extractData)
      .map(this.mapResourceData)
      .catch(this.handleError);
  }

  public store(config: ConfigModel) {
    return this.http.post(this.url('config'), config, this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public destroy(config: ConfigModel) {
    return this.http.delete(this.url(`config/${config._id}`), this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public update(config: ConfigModel) {
    return this.http.put(this.url(`config/${config._id}`), config, this.getRequestOptions())
      .map(this.extractData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

  public updateOrStore(config: ConfigModel, isUpdate = true) {
    if (isUpdate) {
      return this.update(config);
    } else {
      return this.store(config);
    }
  }

  public show(_id) {
    return this.http.get(this.url(`config/${_id}`), this.getRequestOptions())
      .map(this.extractData)
      .map(this.mapResourceData)
      .catch(err => Observable.throw(this.mapErrors(err.json())));
  }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/services/config.service.ts